import styled from 'styled-components'

import logoColor from "../static/images/logo-color.svg";
import { MEDIA_QUERIES } from '../styles/theme';
import { MarginTop16, MarginTop8 } from './margins';

const StyledLogo = styled.a`
    display: block;
    position:relative;
    width: auto;
    height: 37px;
    ${MarginTop8};
    margin-bottom: 26px;
    background-image: url(${logoColor});
    background-color: transparent;
    background-position: left center;
    background-repeat: no-repeat;
    background-size: contain;
    transition: all .4s linear 0s;
    
    ${(props) => props.theme.mediaQueries[MEDIA_QUERIES.tablet]} {
        height: 44px;
        ${MarginTop16};
        margin-bottom: 36px;
    }
`;

export default StyledLogo;